module.exports = __webpack_public_path__ + "static/media/bg16.012f384f.jpg";